import { BotReplyLayout } from "./bot.reply.layout.component";
import { EonUiButton } from "@eon-ui/eon-ui-components-react";
import { useNexthinkContext } from "./nexthink.context";
import { fetchHealthCheckInfo } from "@me8eon/ai.tools.nextthink";
import React, { useState, useCallback, useMemo } from "react";
import DeviceSelectionComponent from "../device.selection.component";
import { useDoAi } from "@me8eon/react_intent";
import { useJwtToken } from "@me8eon/react_authentication";

export const NexthinkHealthCheck = () => {
  const [error, setError] = useState<string | null>(null);
  const { setLoading, setHealthCheckInfo, messageAndData, actionFreeze, setActionFreeze, selectedDevice, setSelectedDevice, localT } =
    useNexthinkContext();
  const {
    data: {deviceDetails},
  } = messageAndData || {};
  const handleAiQuery = useDoAi();
  const jwtTokenFn = useJwtToken();
  const options = useMemo(() => (deviceDetails?.data ?? []).map((device: any) => ({
    value: device["device.collector.uid"],
    label: device["device.name"],
  })), [deviceDetails?.data]);

  const getHealthCheckInfo = useCallback(
    async (id: string) => {
      setLoading(true);
      try {
        const healthCheckInfo = await fetchHealthCheckInfo(id, jwtTokenFn);
        if (healthCheckInfo.data.length) {
          setHealthCheckInfo(healthCheckInfo.data[0]);
        }
      } catch (err: unknown) {
        console.error("Error fetching health check info:", err);
        setError(localT("chatBot.nexthinkIntegration.smartSolution.healthCheckApiFail"));
      } finally {
        setLoading(false);
      }
    },
    [setHealthCheckInfo, setLoading, localT, jwtTokenFn]
  );

  const handleRunHealthCheck = () => {
    if (!selectedDevice.id) return;
    setActionFreeze((prev) => ({ ...prev, healthCheck: true }));
    getHealthCheckInfo(selectedDevice.id);
  };

  const changeDeviceDetails = useCallback((id: string) => {
    const data = {
      id,
      name: deviceDetails?.data?.find((device: any) => device["device.collector.uid"] === id)?.["device.name"] ?? '',
    };
    setSelectedDevice(prev => ({ ...prev, ...data }));
  }, [deviceDetails?.data, setSelectedDevice]);

  return (
    <>
      {selectedDevice.id && <BotReplyLayout>
        <div className="health-check">
          {options.length === 1 && (
            <>
              <span>
                {localT(
                  "chatBot.nexthinkIntegration.smartSolution.systemName"
                )}
                : {selectedDevice.name || ""}
              </span>
              <br />
            </>
          )}
          <span>{localT("chatBot.nexthinkIntegration.smartSolution.acknowledgeQuery")}</span>
          {options.length > 1 && <DeviceSelectionComponent
            value={selectedDevice.id || ''}
            options={options}
            changeHandler={changeDeviceDetails}
            t={t}
          />}
          <p>
            <b>{localT("chatBot.nexthinkIntegration.smartSolution.askToRunHealthCheck")}</b>
          </p>
          <div className="ai-action-btn-wrapper">
            <EonUiButton
              fullWidthOnMobile
              text={localT("chatBot.nexthinkIntegration.smartSolution.primaryBtn")}
              rank="primary"
              size="small"
              disabled={actionFreeze.healthCheck || !selectedDevice.id}
              onClick={handleRunHealthCheck}
            />
          </div>
          {error && <span className="error-message">{error}</span>}
        </div>
      </BotReplyLayout>}
    </>
  );
};
